import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UserService } from '../user/user.service';
import { IDocument } from '../generic';
import { IEventStand } from './event.service';
import { IUser } from '../../model/user.model';

export interface IEventBartender extends IDocument {
  event_id: string;
  user_id: string;
  user?: IUser;
  eventstand_id?: string;
  eventstand?: IEventStand
}

@Injectable({
  providedIn: 'root'
})
export class EventBartenderService {

  constructor(private afStore: AngularFirestore, private userService: UserService) {
  }

  getBartenders(event_id: string) {
    return this.afStore.collection<IEventBartender>('/eventbartender', ref => ref.where('event_id', '==', event_id)).valueChanges({ idField: 'key' });
  }

  getBartender(id: string) {
    return this.afStore.doc<IEventBartender>(`/eventbartender/${id}`).valueChanges({ idField: 'key' });
  }

  updateBartender(eventBartenderId: string, eventStandId: string) {
    return this.afStore.doc<IEventBartender>(`/eventbartender/${eventBartenderId}`).update({
      eventstand_id: eventStandId
    })
  }

  addBartender(eventBartender: IEventBartender) {
    return this.afStore
      .collection<IEventBartender>(`/eventbartender`, (ref) =>
        ref
          .where('user_id', '==', eventBartender.user_id)
          .where('event_id', '==', eventBartender.event_id)
      )
      .get().toPromise()
      .then((bartender) => {
        if (bartender.size === 0) {
          return this.afStore
            .doc(
              `/event/${eventBartender.event_id}/eventuser/${eventBartender.user_id}`
            )
            .set(
              {
                user_id: eventBartender.user_id,
                event_id: eventBartender.event_id,
                active: true,
                bartender: true
              },
              { merge: true }
            )
            .then(() =>
              this.afStore
                .collection<IEventBartender>(`/eventbartender`)
                .add(eventBartender)
            );
        } else {
          throw 'This user is already bartender';
        }
      });
  }

  deleteBartender(id: string) {
    return this.afStore.doc<IEventBartender>(`/eventbartender/${id}`).delete();
  }

}
